import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import {
  useLoadScript,
} from "@react-google-maps/api";
import {
  GetCirclebyID,
  GetWardsbyCircleId,
  GetZone,
} from "../../Apis/organizationApi";
import { SATDashboard } from "../../Apis/DashboardApis/SatsDashboardApi";
import { getAllTransferStationMaster } from "../../Apis/transferStationApi";
import { AllOwnerTypeDetails } from "../../Apis/ownerTypeApi";
import Loader from "../../Common/Loader/loader";
import { getMasterAPIStore } from "../../../utils/getMasterAPIStore";
import {  getOneMonthPastDate, getTodayDate } from "../AssetVehicle/utils/helpers";

const SatsDashboard = () => {
  const libraries = ["places"];
  const { zoneData, zoneLoading, circleData, circleLoading, wardData, wardLoading } = getMasterAPIStore();

  // const transferStationDashboardResults = require("./transferStationZones.json");
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedTransferStation, setSelectedTransferStation] = useState(null);
  const [allSatDashboardReport, setAllSatDashboardReport] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [selectedCircle, setSelectedCircle] = useState(null);
  const [selectedWard, setSelectedWard] = useState(null);
  const [selectedOwnerType, setSelectedOwnerType] = useState(null);
  const [startDate, setStartDate] = useState(getCurrentDateTime());
  // const [endDate, setEndDate] = useState(getCurrentDateTime());
  const chartRef = useRef(null);
  //const [selectedTransferStationLatLng, setSelectedTransferStationLatLng] = useState(null);
  const [SatDashbordResults, setSatDashbordResults] = useState([]);
  const [ownerTypeDashboard, setOwnerTypeDashboard] = useState([]);

  const [mapCenter, setMapCenter] = useState({
    lat: 17.385044,
    lng: 78.486671,
  });
  const resetRef = useRef(null);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyAm9ekbF8SnmFeUH4BvEffHYu_TuUieoDw", // Replace with your Google Maps API key
    libraries,
  });

  useEffect(() => {
    const fetchTransferStations = async () => {
      try {
        const transferStationData = await getAllTransferStationMaster();
        // Assuming the data structure returned by the API matches your expectations
        // Set the transfer station results state
        setSatDashbordResults(transferStationData);
      } catch (error) {
        console.error("Error fetching transfer station data:", error);
      }
    };

    // Call the function to fetch transfer station data
    fetchTransferStations();
  }, []);

  // Modify this function to return an object with vehicle type IDs as keys and their names as values
  useEffect(() => {
    const fetchOwnerTypeNames = async () => {
      try {
        const ownerData = await AllOwnerTypeDetails();
        setOwnerTypeDashboard(ownerData);
      } catch (error) {
        console.error("Error fetching all Owners types:", error);
      }
    };
    fetchOwnerTypeNames();
  }, []);

  // const fetchOwnerTypeNames = async () => {
  //     const vehicleTypeNames = await fetchOwnerTypeNames();
  //     setAllVehicleTypeNames(vehicleTypeNames);
  // };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsOptionsLoading(true);
        // Call both APIs when start date or end date changes
        const SatsResponse = await SATDashboard(
          startDate,
          selectedZone,
          selectedCircle,
          selectedWard,
          selectedTransferStation,
          selectedOwnerType
        );
        setAllSatDashboardReport(SatsResponse.data);
        // Update state variables with response data
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsOptionsLoading(false);
      }
    };

    // Fetch data only if start date and end date are selected
    if (startDate) {
      fetchData();
    }
  }, [
    startDate,

    selectedZone,
    selectedCircle,
    selectedWard,
    selectedTransferStation,
    selectedOwnerType,
  ]);

  useEffect(() => {
    if (
      (selectedZone || selectedCircle || selectedWard || selectedOwnerType) &&
      SatDashbordResults.length > 0
    ) {
      // Filter transfer stations based on the selected zone, circle, and ward
      let filteredStations = SatDashbordResults;
      if (selectedZone) {
        filteredStations = filteredStations.filter(
          (station) => station.zoneId === selectedZone
        );
      }
      if (selectedCircle) {
        filteredStations = filteredStations.filter(
          (station) => station.circle_id === selectedCircle
        );
      }
      if (selectedWard) {
        filteredStations = filteredStations.filter(
          (station) => station.ward_id === selectedWard
        );
      }
      if (selectedOwnerType) {
        filteredStations = filteredStations.filter(
          (station) => station.owner_id === selectedOwnerType
        );
      }
    }
  }, [
    selectedZone,
    selectedCircle,
    selectedWard,
    selectedOwnerType,
    SatDashbordResults,
  ]);


  const prepareChartData = () => {
    // Initialize arrays to store labels and data
    let labels = [];
    let data = [];

    // Iterate through each item in allSatDashboardReport
    allSatDashboardReport.forEach((item) => {
      // Extract keys and values from the current item
      const itemLabels = Object.keys(item);
      const itemData = Object.values(item);

      // Add labels and data from the current item to the respective arrays
      labels = labels.concat(itemLabels);
      data = data.concat(itemData);
    });

    return { labels, data };
  };

  // Function to render the chart
  const renderChart = () => {
    const chartContainer = document.getElementById("chartContainer");
    const noDataMessage = document.getElementById("noDataMessage");
    const ctx = document.getElementById("myChart");
  
    if (!ctx || !chartContainer || !noDataMessage) return;
  
    const data = prepareChartData();
    const hasData = data.data.some((value) => value > 0);
  
    // Destroy existing chart if it exists
    if (chartRef.current !== null) {
      chartRef.current.destroy();
    }
  
    // Show/Hide chart and message based on data availability
    if (!hasData) {
      chartContainer.style.display = "none";  
      noDataMessage.style.display = "block";  
      return;
    } else {
      chartContainer.style.display = "block";  
      noDataMessage.style.display = "none";    
    }
  
    // Function to format labels (add space before uppercase but not between letters)
    const formatLabel = (label) =>
      label.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase(); 
  
    // Render Pie Chart
    chartRef.current = new Chart(ctx, {
      type: "pie",
      data: {
        labels: data.labels.map(formatLabel), // Format legend labels
        datasets: [
          {
            data: data.data,
            backgroundColor: COLORS.slice(0, data.labels.length),
            borderColor: "transparent",
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: hasData }, 
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                const label = formatLabel(tooltipItem.label); 
                const value = tooltipItem.raw; // Get count value
                return value; // Show label + count
              },
            },
          },
        },
      },
    });
  };
  
  



  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF'];
  // const generateColors = (count) => {
  //   const colors = [];
  //   for (let i = 0; i < count; i++) {
  //     const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(
  //       Math.random() * 256
  //     )}, ${Math.floor(Math.random() * 256)}, 0.8)`; // Adjust the alpha value here
  //     colors.push(color);
  //   }
  //   return colors;
  // };



  // Use useEffect to render the chart when allSatDashboardReport changes
  useEffect(() => {
    renderChart();
  }, [allSatDashboardReport]);

  const vehicleTypeMapping = {
    totalSat: 'Total SATs',
    activeVehicle: 'Active Vehicle',
    inActiveVehicle: 'InActive Vehicle',
    reportedAtWardCount: 'Reported at Ward',
    reportedAtWardNotTSCount: 'Reported at Ward But Not at TS',
    reportedAtTSCount: 'Reported at TS',
    reportedAtTSNotWardCount: 'Reported at TS But Not at Ward',
    reportedAtTSAndWardCount: 'Reported at TS and Ward'
    // Add other mappings if needed
    // Example:
    // 'otherVehicleTypeKey': 'DisplayName',
  };
  const getDisplayName = (vehicleType) => {
    return vehicleTypeMapping[vehicleType] || vehicleType; // Default to the original if no mapping exists
  };


  // const displayNames={
  //   totalsat:"Total SAT",
  //   activeVehicle:"Active Vehicle",
  //   inActiveVehicle:"InActive Vehicle",
  //   reportedAtWardCount: "Reported at Ward Count",
  //   reportedAtWardNotTSCount:"Reported at Ward Not TS Count",
  //   reportedAtTSCount: "Reported at TS Count",
  //   reportedAtTSNotWardCount:"Reported at TS not Ward Count",
  //   reportedAtTSAndWardCount:"Reported at TS & Ward Count "
  // }
  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content ">
          <h4 class="text-start mb-3">SATs Dashboard</h4>
          <div className="card">
            <div className="card-body">


              <div className="row" style={{ textAlign: "justify" }}>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="toDate">Select Transfer Station Name</label>
                    <select
                      type="text"
                      name="point_name"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedTransferStation}
                      onChange={(e) => {
                        setSelectedTransferStation(e.target.value);
                        // Find the selected transfer station by name
                        const selectedStation = SatDashbordResults.find(
                          (station) => station.transferStationId == e.target.value
                        );
                        // Clear selected zone and circle to avoid conflicts
                        setSelectedZone("");
                        setSelectedCircle("");
                      }}
                    >
                      <option value="">All</option>
                      {SatDashbordResults.filter((station)=>station.isActive).map((station) => (
                        <option
                          key={station.transferStationId}
                          value={station.transferStationId}
                        >
                          {station.transferStationName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="fromDate">Select Date</label>
                    <input
                      type="date"
                      className="form-control"
                      id="fromDate"
                      name="fromDate"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={startDate}
                      min={getOneMonthPastDate()}
                      max={getTodayDate()}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                </div>

                <div class="col-md-4">
                  <div className="form-group">
                    <label htmlFor="zone">Select Owner Type</label>
                    <select
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      name="owner_id"
                      value={selectedOwnerType}
                      onChange={(e) => {
                        setSelectedOwnerType(e.target.value);
                        // Find the selected transfer station by name
                        const selectedOwner = ownerTypeDashboard.find(
                          (owner) => owner.ownerTypeId == e.target.value
                        );
                        // Clear selected zone and circle to avoid conflicts
                        setSelectedZone("");
                        setSelectedCircle("");
                      }}
                    >
                      <option value="">All</option>
                      {ownerTypeDashboard.filter((owner)=>owner.isActive).map((owner) => (
                        <option key={owner.ownerTypeId} value={owner.ownerTypeId}>
                          {owner.ownerTypeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row" style={{ textAlign: "justify" }}>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="zone">Select Zone</label>
                    <select
                      type="text"
                      name="zoneId"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedZone}
                      onChange={(e) => {
                        if (e.target.value === "") {
                          // Clear selected circle and transfer station when "All Zones" is selected
                          setSelectedCircle("");
                          setSelectedWard(""); // Assuming an empty string represents no selection
                        }
                        setSelectedZone(e.target.value);
                      }}
                    >
                      <option value="">All</option>
                      {zoneData.filter((zone)=>zone.isActive).map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="zone">Select Circle</label>
                    <select
                      type="text"
                      name="circle_id"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedCircle}
                      onChange={(e) => {
                        setSelectedCircle(e.target.value);
                        setSelectedWard(null); // Clear the selected ward
                      }}
                    >
                      <option value="">All</option>
                      {circleData.filter(circle=> selectedZone ? (circle.zoneId==selectedZone) : circle).map((circle) => (
                        <option
                          key={circle.circleId}
                          value={circle.circleId}
                          selected={circle.circleId === selectedCircle}
                        >
                          {circle.circleName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="zone">Select Ward</label>
                    <select
                      type="text"
                      name="ward_id"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedWard}
                      onChange={(e) => {
                        setSelectedWard(e.target.value);
                      }}
                    >
                      <option value="">All</option>
                      {wardData.filter(ward=> selectedCircle ? (ward.circleId==selectedCircle) : ward).map((ward) => (
                        <option
                          key={ward.wardId}
                          value={ward.wardId}
                          selected={ward.wardId === selectedWard}
                        >
                          {ward.wardName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {isOptionsLoading && <Loader />}
          <div className="row">
            {allSatDashboardReport.length > 0 ? (
              <div className="col-md-12">
                <div className="d-flex flex-wrap">
                  {allSatDashboardReport.map((item, index) => {
                    return (
                      <div className="col-md-12 mb-3 px-0" key={index}>
                        <div className="row g-3">
                          {Object.entries(item).map(([key, value], idx) => (
                            // const displayName = displayNames[key] || key; 
                            <div className="col-md-3" key={idx}>
                              <div
                                className="card shadow "
                                style={{
                                  textAlign: "justify",
                                }}
                              >
                                <div
                                  className="card-body card_text_no"
                                >
                                  <span className="card-title">
                                    {/* {key} */}
                                    {getDisplayName(key)}
                                  </span>
                                  <p
                                    className="card-text"

                                  >
                                    {value}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}

                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="col-md-12">
                <div className="alert alert-danger">No data available</div>
              </div>
            )}

            <div className="col-md-12 me-auto ">
              <div className="card">
                <div className="card-header">
                  SATs Dashboard Chart
                </div>
                <div className="card-body text-center p-3">
                  <div style={{ width: "400px", height: "400px", margin: "auto" }}>
                    <div id="chartContainer">
                      <canvas id="myChart"></canvas>
                    </div>
                    <p id="noDataMessage" style={{display: "none", textAlign: "center", fontSize: "16px", color: "#666"}}>
                    No Preview available as data does not exists
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SatsDashboard;

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
